import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { FaCoins } from 'react-icons/fa';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [tokens, setTokens] = useState(null);

  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    navigate('/');
  };

  const isLoggedIn = !!localStorage.getItem('accessToken');

  // Fetch tokens when logged in
  useEffect(() => {
    const fetchTokens = async () => {
      if (!isLoggedIn) {
        setTokens(null);
        return;
      }

      try {
        const token = localStorage.getItem('accessToken');
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_SERVER_URI}/user/tokens`,
          {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          }
        );
        setTokens(response.data.tokens);
      } catch (error) {
        console.error('Error fetching tokens:', error);
      }
    };

    // Fetch tokens when the component mounts or location changes
    fetchTokens();

    // Listen for token changes (e.g., after getting recommendations)
    const handleTokenChange = () => fetchTokens();
    window.addEventListener('tokenChange', handleTokenChange);

    return () => {
      window.removeEventListener('tokenChange', handleTokenChange);
    };
  }, [isLoggedIn, location.pathname]);

  // Hide navbar on landing page (after all hooks)
  if (location.pathname === '/') {
    return null;
  }

  return (
    <nav className="bg-white border-b border-gray-200 py-4 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 flex justify-between items-center">
        {/* Logo/Brand */}
        <div 
          className="text-2xl font-bold text-gray-900 cursor-pointer tracking-tight"
          onClick={() => navigate('/')}
        >
          CineSense
        </div>

        {/* Nav Links */}
        <div className="flex gap-4 items-center">
          {isLoggedIn ? (
            <>
              <button 
                onClick={() => navigate('/recommend')} 
                className="px-5 py-2 text-sm font-medium text-gray-900 bg-transparent rounded-md hover:bg-gray-100 transition-all duration-200"
              >
                Recommendations
              </button>
              <button 
                onClick={() => navigate('/history')} 
                className="px-5 py-2 text-sm font-medium text-gray-900 bg-transparent rounded-md hover:bg-gray-100 transition-all duration-200"
              >
                History
              </button>
              
              {/* Token Display */}
              {tokens !== null && (
                <div className="flex items-center gap-2 px-4 py-2 bg-gray-100 rounded-md">
                  <div className="text-black-500">Tokens:</div>
                  <span className="text-sm font-semibold text-gray-900">{tokens}</span>
                </div>
              )}
              
              <button 
                onClick={handleLogout} 
                className="px-5 py-2 text-sm font-medium text-red-600 bg-transparent rounded-md hover:bg-red-50 transition-all duration-200"
              >
                Logout
              </button>
            </>
          ) : (
            <>
              <button 
                onClick={() => navigate('/login')} 
                className="px-5 py-2 text-sm font-medium text-gray-900 bg-transparent rounded-md hover:bg-gray-100 transition-all duration-200"
              >
                Login
              </button>
              <button 
                onClick={() => navigate('/signup')} 
                className="px-5 py-2 text-sm font-medium text-white bg-gray-900 rounded-md hover:bg-gray-800 transition-all duration-200"
              >
                Register
              </button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
